import React from 'react';
import { motion } from 'framer-motion';
export function StartToday() {
  return <section className="w-full bg-[#F7F2E7] py-20 px-6" data-id="element-240" data-mp="1v6zkay4q5lut">
      <div className="max-w-3xl mx-auto text-center" data-id="element-241" data-mp="1v7j30h278e9w">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-[#0A1535] mb-8" data-id="element-242" data-mp="1z8cq587thp1q">
          Hoy puedes comenzar
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-4 text-lg md:text-xl text-[#0A1535] leading-relaxed" data-id="element-243" data-mp="2ixdeovas7wsk">
          <p data-id="element-244" data-mp="35oq43qk1d4f4">No necesitas tener todas las respuestas.</p>
          <p data-id="element-245" data-mp="30p3t7nrok09h">No necesitas ser perfecto/a.</p>
          <p data-id="element-246" data-mp="30o2dh5zpyplf">No necesitas esperar el momento ideal.</p>
          <p className="font-semibold text-[#C9A24B]" data-id="element-247" data-mp="2wmyzkp18f3mu">
            Solo necesitas estar dispuesto/a a dar el primer paso.
          </p>
          <p className="pt-4" data-id="element-248" data-mp="2rph1jtor68tm">Dios ya está obrando en tu historia.</p>
          <p data-id="element-249" data-mp="3oey4w209jis5">
            Tal vez este sea el momento que estabas esperando para acercarte
            nuevamente a Él — con un proceso que te acompañe de verdad.
          </p>
        </motion.div>
      </div>
    </section>;
}